import { Box } from '@mui/material';
import { courseStageColorKey, type CourseStage } from '../model';

/** A dot in the stage's own colour, the colour that identifies the stage wherever it is named. */
export default function CourseStageDot({
    stage,
    size = 6,
}: {
    stage: CourseStage;
    size?: number;
}) {
    return (
        <Box
            component="span"
            aria-hidden
            sx={{
                width: size,
                height: size,
                flexShrink: 0,
                borderRadius: '50%',
                bgcolor: (theme) =>
                    theme.palette.courseStage[courseStageColorKey(stage)],
            }}
        />
    );
}
